import axios from 'src/utils/axios';
import axiosFiles from 'axios';

export const errorHandler = error => {
  let messages = '';

  if (!error) {
    messages = 'Erro interno de servidor.';
  } else {
    const status = error?.response?.status;
    messages =
      error?.response?.data?.messages ||
      error?.response?.data?.message ||
      500;

    switch (status) {
      case 404:
        messages = `Não foi possível comunicar com o servidor da aplicação. Código: ${status}`;
        break;
      case 401:
        messages =
          error?.response?.data?.message ||
          `Acesso negado, favor faça o login. Código: ${status}`;
        break;
      case 500:
        messages = 'Servidor indisponível no momento';
        break;

      default:
        if (!messages) {
          messages = error?.message || 'Servidor indisponível no momento';
        }
        break;
    }
  }

  return messages;
};

export const getRequest = (url, resolve, reject) =>
  axios
    .get(url)
    .then(response => {
      const { data } = response;

      resolve(data);
    })
    .catch(error => {
      const messages = errorHandler(error);

      reject(messages);
    });

export const getRequestWithParams = ({ url, resolve, reject, params }) =>
  axios
    .get(url, {
      params: { ...params },
    })
    .then(response => {
      const { data } = response;
      resolve(data);
    })
    .catch(error => {
      const messages = errorHandler(error);

      reject(messages);
    });

export const postRequest = (url, data, resolve, reject) => {
  return axios
    .post(url, data)
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

export const postFilesRequest = ({ url, data, resolve, reject }) => {
  return axiosFiles
    .post(url, data, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

export const putRequest = (url, data, resolve, reject) => {
  return axios
    .put(url, data)
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);
      reject(messages);
    });
};

export const deleteRequest = (url, data, resolve, reject) => {
  return axios
    .delete(url, {
      data: { ...data },
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(error => {
      const messages = errorHandler(error);

      reject(messages);
    });
};
